import PropTypes from 'prop-types'

function RadioField({
  name,
  onChange,
  label,
  value,
  checked,
  disabled,
  additionalClass,
  isError,
  ...props
}) {
  return (
    <div
      className={`field field-radio ${additionalClass || ''} ${isError ? 'is-danger' : ''} ${
        disabled ? 'is-disabled' : ''
      }`}
    >
      <input
        type="radio"
        name={name}
        onChange={onChange}
        value={value}
        checked={checked}
        id={`${name}-${value}`}
        disabled={disabled}
        {...props}
      />
      <label
        className="radio"
        htmlFor={`${name}-${value}`}
        onClick={() => {
          if (disabled) {
            return
          }
          onChange({ target: { value } })
        }}
        data-tip={props['data-tip']}
        data-for={props['data-for']}
      >
        {label}
      </label>
    </div>
  )
}

RadioField.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  value: PropTypes.string,
  additionalClass: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  isError: PropTypes.bool,
  id: PropTypes.string,
  'data-tip': PropTypes.string,
  'data-for': PropTypes.string,
}

export default RadioField
